<template>
  <div class="tasksList">
    <job-header-simple header_title="我的任务" backRouter="/user"></job-header-simple>
    <van-sticky :z-index="99" offset-top="1.22667rem">
      <van-row>
        <van-col span="6" class="item_tab" @click="isTasksTypeClicked = true">
          <p class="van-ellipsis">{{tasksText}}</p>
          <van-icon name="arrow-up" class="icon" v-if="isTasksTypeClicked" />
          <van-icon name="arrow-down" class="icon" v-else />
        </van-col>
        <van-col span="6" class="item_tab" @click="isStatusClicked = true">
          <p class="van-ellipsis">{{status}}</p>
          <van-icon name="arrow-up" class="icon" v-if="isStatusClicked" />
          <van-icon name="arrow-down" class="icon" v-else />
        </van-col>
        <van-col span="12" class="item_tab">
          <van-search v-model="formSearch.taskName" shape="round" placeholder="搜索任务名称" @search="onSearch" @clear="onClear" />
        </van-col>
      </van-row>
    </van-sticky>
    <div class="public_empty_section message" v-if="list.length == 0">暂无任务</div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="init" :error.sync="error" error-text="请求失败，点击重新加载">
      <section class="item" v-for="(item, index) in list" :key="index" @click="handleDetail(item.taskId)">
        <van-row>
          <van-col span="12">
            <div class="title van-ellipsis">{{item.ecompanyJobCategoryName}}</div>
          </van-col>
          <van-col span="12" class="fee van-ellipsis">{{item.taskMoney}}</van-col>
        </van-row>
        <p class="van-ellipsis">{{item.taskName}}</p>
        <div class="van-ellipsis"> 地&nbsp;&nbsp;&nbsp;区: {{item.cityName?item.cityName:'不限'}} </div>
        <div class="van-ellipsis"> 任务发布方: {{item.ecompanyName}} </div>
        <div class="endTime"> 截止时间: <template v-if="item.lastApplyDate == undefined">长期有效</template>
          <template v-else-if="(timeLeftCount(item.lastApplyDate) <= 0) || (item.applyStatus == 'stop')">已截止</template>
          <template v-else>{{item.lastApplyDate}}</template>
        </div>
        <van-button type="info" size="small" v-if="item.employeeTaskStatus == 'applying'">申请中</van-button>
        <van-button type="default" size="small" v-if="item.employeeTaskStatus == 'cancelled'">已作废</van-button>
        <van-button type="primary" size="small" v-if="item.employeeTaskStatus == 'finish'">已完成</van-button>
        <van-button type="danger" size="small" v-if="item.employeeTaskStatus == 'nopass'">未通过</van-button>
        <template v-else-if="item.employeeTaskStatus == 'doing'">
          <van-button type="primary" size="small" v-if="item.contractStatus == 'wsign'" @click.stop.prevent="goSign(item.contractEmployeeId,item.ocompanyId)">去签署</van-button>
          <van-button type="info" size="small" v-else-if="item.contractStatus == 'signed'">交付任务</van-button>
          <van-button type="info" size="small" v-else>进行中</van-button>
        </template>
      </section>
    </van-list>
    <van-popup v-model="isTasksTypeClicked" position="bottom">
      <van-picker title="任务类型" show-toolbar :columns="tasksTypeList" @confirm="handleTasksTypeConfirm" @cancel="isTasksTypeClicked=false;finished = true;tasksText='任务类型';formSearch.ecompanyJobCategoryId=null;list = [];init(1);" />
    </van-popup>
    <van-popup v-model="isStatusClicked" position="bottom">
      <van-picker title="任务状态" show-toolbar :columns="statusList" @confirm="handleStatusConfirm" @cancel="isStatusClicked=false;finished = true;status='任务状态';formSearch.taskStatus=null;list = [];init(1);" />
    </van-popup>
  </div>
</template>
<script>
import jobHeaderSimple from "@/components/header/header.vue";
import { pageByEmployee, selectByAccount } from "@/api/contract/taskRequest";
import {
  Sticky,
  Col,
  Row,
  Search,
  Icon,
  Button,
  Popup,
  Picker,
  Notify,
  List,
  CountDown,
  Dialog
} from "vant";
import {
  getIndividualHeaderKey
} from "@/utils/auth";
import {
  itemStatusHttpAction,
} from "@/api/businessStatus/request";

export default {
  components: {
    jobHeaderSimple,
    [Sticky.name]: Sticky,
    [Col.name]: Col,
    [Row.name]: Row,
    [Search.name]: Search,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Notify.name]: Notify,
    [List.name]: List,
    [CountDown.name]: CountDown,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      isTasksTypeClicked: false,
      isStatusClicked: false,
      tasksText: "任务类型",
      status: "任务状态",
      statusId: -1,
      textNameSearch: "",
      error: false,
      loading: false,
      finished: false,
      list: [],
      tasksTypeList: [],
      type: 0,

      statusList: [
        {
          text: "申请中",
          value: "applying",
        },
        {
          text: "已作废",
          value: "cancelled",
        },
        {
          text: "进行中",
          value: "doing",
        },
        {
          text: "已完成",
          value: "finish",
        },
        {
          text: "未通过",
          value: "nopass",
        },
      ],
      formSearch: {},
      page: {
        current: 0,
        size: 10,
        total: 1,
      },
    };
  },
  created() {
    if(getIndividualHeaderKey()){ this.type = 1}
    this.select();
  },
  methods: {
    select() {
      selectByAccount().then((res) => {
        for (let temp of res.data.data) {
          this.tasksTypeList.push({
            text: temp.name,
            value: temp.id,
          });
        }
      });
    },
    timeLeftCount(data) {
      return new Date(data.replace(/-/g, "/")).getTime() - new Date().getTime();
    },
    onSearch() {
      this.finished = false;
      this.list = [];
      this.init(1);
    },
    onClear() {
      this.finished = false;
      this.list = [];
      this.init(1);
    },
    handleTasksTypeConfirm(value) {
      this.formSearch.ecompanyJobCategoryId = value.value;
      this.tasksText = value.text;
      this.isTasksTypeClicked = false;
      this.finished = false;
      this.list = [];
      this.init(1);
    },
    handleStatusConfirm(value) {
      this.formSearch.taskStatus = value.value;
      this.status = value.text;
      this.isStatusClicked = false;
      this.finished = false;
      this.list = [];
      this.init(1);
    },
    init(value) {
      let param = this.formSearch;
      if (typeof value == "undefined") {
        if (this.page.current >= this.page.total) {
          setTimeout(function () {
            this.finished = true;
            this.loading = false;
          }, 50);
          return;
        }
        param.current = this.page.current + 1;
      } else {
        param.current = 1;
      }
      param.size = this.page.size;
      param.type = this.type;
      pageByEmployee(param)
        .then((res) => {
          if (res.data.status == "200") {
            // 加载状态结束
            this.loading = false;
            this.page.current = res.data.data.current;
            this.page.total = res.data.data.pages;
            this.page.size = res.data.data.size;
            let records = res.data.data.records;
            if (res.data.data.current >= res.data.data.pages) {
              this.finished = true;
            }
            for (let record of records) {
              this.list.push(record);
            }
          } else {
            this.error = true;
            this.$notify({
              message: res.data.message,
              type: "danger",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },
    goSign(id,ocompanyId) {
      if (getIndividualHeaderKey()) {
        itemStatusHttpAction(ocompanyId).then((res) => {
          if (res.status == "200"&&res.data.data.flag) {
              this.$router.push({
                path: "/individual_baseInfo",
                query: { obj: id,ocompanyId: ocompanyId},
              });
          }else {
              if(res.data.data.type==1){
                Dialog.alert({
                  title: '温馨提示',
                  message: '请先完成个体户认证与注册！',
                  confirmButtonText: '去认证'
                })
                .then(() => {
                  this.$router.push("/individual_list")
                })
              }else if (res.data.data.type==3){
                Dialog.alert({
                  title: '温馨提示',
                  message: '个体户已注销，不支持签约！',
                  confirmButtonText: '确认'
                })

              }else{
                Dialog.alert({
                  title: '温馨提示',
                  message: '个体户正在注销中，暂不支持签约！',
                  confirmButtonText: '确认'
                })
              }
          }
        });
      }else {
        this.$router.push({path:'/contractBase',query: {obj: id}})
      }
    },
    handleDetail(id) {
      this.$router.push({ path: "/myTasksDetail", query: { id: id } });
    },
  },
};
</script>

<style lang="less" scoped>
.tasksList {
  /deep/.van-sticky {
    background: #fff;
    font-size: 14px;
    text-align: center;
    p {
      display: inline-block;
      vertical-align: middle;
      max-width: 4em;
    }
    .van-col {
      line-height: 50px;
    }

    .icon {
      vertical-align: middle;
      margin-top: -2px;
    }

    .van-search {
      padding: 8px;
    }
  }
}
.item {
  position: relative;
  margin: 8px;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  color: #666;
  line-height: 20px;
  padding: 12px;
  /deep/ .van-row {
    font-size: 14px;
    line-height: 30px;
    font-weight: 800;
    .title {
      color: #333;
    }
    .fee {
      color: #f3852c;
      text-align: right;
      padding-right: 10px;
    }
  }

  p {
    margin-bottom: 16px;
  }

  .type {
    float: right;
    margin-left: 6px;
  }

  .icon {
    position: relative;
    top: 2px;
  }

  /deep/ .van-button {
    width: 80px;
    height: 1rem;
    position: absolute;
    right: 12px;
    bottom: 20px;
  }
}
.public_empty_section {
  top: 100px;
}
</style>